/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ShieldCheckIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="m3.783 2.82 8-1.796a1 1 0 0 1 .434 0l8 1.796c.457.103.783.513.783.987v10.09a6.08 6.08 0 0 1-2.672 5.044l-5.773 3.89a.99.99 0 0 1-1.11 0l-5.773-3.89A6.08 6.08 0 0 1 3 13.897V3.807c0-.474.326-.884.783-.987m12.394 4.29a1.17 1.17 0 0 1 .252 1.623l-4.375 6.062a1.143 1.143 0 0 1-1.734.146l-2.625-2.599a1.17 1.17 0 0 1-.017-1.643 1.14 1.14 0 0 1 1.627-.017l1.675 1.658 3.59-4.977a1.14 1.14 0 0 1 1.607-.254" clipRule="evenodd" /></svg>;
};
export default ShieldCheckIcon;